var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4378_13578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79718 1.88867C7.36062 3.33317 7.3241 4.86905 7.69151 6.33267C8.05893 7.79629 8.81652 9.13282 9.88356 10.1999C10.9506 11.2669 12.2871 12.0245 13.7508 12.3919C15.2144 12.7593 16.7502 12.7228 18.1947 12.2862C17.776 13.6631 17.0078 14.9081 15.9649 15.8999C14.922 16.8917 13.6401 17.5966 12.2439 17.9457C10.8477 18.2949 9.38492 18.2766 7.99794 17.8925C6.61096 17.5084 5.3471 16.7716 4.32945 15.754C3.3118 14.7363 2.57504 13.4725 2.19094 12.0855C1.80684 10.6985 1.78849 9.23569 2.13768 7.83952C2.48686 6.44334 3.19168 5.16139 4.18349 4.11853C5.17529 3.07567 6.42028 2.30744 7.79718 1.88867Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4378_13578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgMoon;